export default __webpack_public_path__ + "static/media/G0690.34I-26420_-16263_0.1666268100000.aaaf9ba6.jpg";